import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import CreateUnitItemDraftService from '../../../services/CreateUnitItemDraftService';
import CreateUnitItemDraftDialog from './CreateUnitItemDraftDialog';

class CreateUnitItemDraftDialogContainer extends Component {
  static propTypes = {
    module: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    unit: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  };

  componentWillMount() {
    CreateUnitItemDraftService.init();
  }

  render() {
    return (
      <CreateUnitItemDraftDialog
        module={this.props.module}
        unit={this.props.unit}
        isOpen={CreateUnitItemDraftService.isOpen}
        onCancel={CreateUnitItemDraftService.handleClose}
        unitItem={CreateUnitItemDraftService.unitItem}
        onSubmit={CreateUnitItemDraftService.handleSubmit}
        onChange={CreateUnitItemDraftService.form.setValue}
        values={CreateUnitItemDraftService.form.getValues()}
        errors={CreateUnitItemDraftService.form.errors}
        submitting={CreateUnitItemDraftService.submit.fetching}
        isDirty={CreateUnitItemDraftService.form.isDirty}
      />
    );
  }
}

export default observer(CreateUnitItemDraftDialogContainer);
